/**
 * Hydrates the interactive parts of server-rendered pages ("islands").
 * Each island's code is loaded only on pages that use it.
 */
import { createElement } from 'react';
import { hydrateRoot } from 'react-dom/client';

const registry: Record<string, () => Promise<{ default: (p: any) => any }>> = {
  BookingWizard: () => import('./islands/BookingWizard.tsx'),
  QuoteFlow: () => import('./islands/QuoteFlow.tsx'),
  FieldActions: () => import('./islands/FieldActions.tsx'),
  PhotoUploader: () => import('./islands/PhotoUploader.tsx'),
  Checklist: () => import('./islands/Checklist.tsx'),
  PricePreview: () => import('./islands/PricePreview.tsx'),
  CardForm: () => import('./islands/CardForm.tsx'),
};

async function boot(): Promise<void> {
  const nodes = document.querySelectorAll<HTMLElement>('[data-island]');
  for (const el of nodes) {
    const name = el.dataset.island!;
    const load = registry[name];
    if (!load) continue;
    try {
      const mod = await load();
      const props = JSON.parse(el.dataset.props ?? '{}');
      hydrateRoot(el, createElement(mod.default, props));
    } catch (e) {
      console.error('island failed', name, e);
    }
  }
}

void boot();
